export async function getTokenInfo(token) {
    const tokenInfoRes = await fetch('https://www.wixapis.com/oauth2/token-info', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            token,
        }),
    });
    if (tokenInfoRes.status !== 200) {
        throw new Error(`Failed to get token info. Unexpected status code from Wix OAuth API: ${tokenInfoRes.status}`);
    }
    return (await tokenInfoRes.json());
}
